export default "__VITE_ASSET__4eeb414f__"